import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`More About Me`}</h1>
    <p>{`On thing about me is I can code a lot  and `}</p>
    <p>{`I love watching youtube `}<a parentName="p" {...{
        "href": "https://www.youtube.com/user/PewDiePie"
      }}>{`PewDiePie`}</a>{` / `}<a parentName="p" {...{
        "href": "https://www.youtube.com/user/CinnamonToastKen"
      }}>{`Ken`}</a>{`.`}</p>
    <p>{`Minecraft is not a kid game just try  it.If you want more challenge try `}<a parentName="p" {...{
        "href": "https://www.curseforge.com/minecraft/mc-mods/ender-io"
      }}>{`Ender IO`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      